import { useState, useCallback } from 'react'

import { Button, Icon } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import type { GridItem as Item } from '../CopyGrid/CopyGrid'

export const CopyItem: React.FC<Item> = ({ id, label, value }) => {
  const { t: tCommon } = useTranslation('common')

  const [copyIconName, setCopyIconName] = useState<
    'CheckOutline' | 'DuplicateSolid'
  >('DuplicateSolid')

  const handleCopyClick = useCallback(() => {
    setCopyIconName('CheckOutline')
    void navigator.clipboard.writeText(value ?? '')

    setTimeout(() => {
      setCopyIconName('DuplicateSolid')
    }, 3000)
  }, [value])

  return (
    <div
      key={id}
      className="flex items-center justify-between"
      data-testid={id}
    >
      <div className="flex flex-col">
        <p className="text-neutral type-body-sm-bold">{label}</p>
        <p className="text-neutral type-body-sm">{value}</p>
      </div>
      <Button
        className="text-icon-neutral"
        label={tCommon('copy')}
        onClick={handleCopyClick}
        variant="text"
        iconOnly
      >
        <Icon name={copyIconName} size={24} />
      </Button>
    </div>
  )
}
